<template>
  <div
    class="tab-pane fade"
    id="gambar"
    role="tabpanel"
    aria-labelledby="gambar-tab"
  >
    <div class="card-group">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title">
            Logo : *Max 500 kb, type file (jpg or png)
          </h5>
          <div class="text-center py-3">
            <img
              :src="user.image.primary"
              class="img-fluid"
              onerror="imgError(this)"
              width="30%"
            />
          </div>
        </div>
        <form @submit.prevent="editPicture">
          <label for="logo"></label>
          <input
            type="file"
            class="form-control-file ml-3"
            name="editLogo"
            id="editLogo"
          />
          <div class="form-group"></div>
          <div class="text-center">
            <button type="submit" class="btn btn-info my-3">
              {{ loading ? "" : "Update Logo" }}
            </button>
          </div>
        </form>
      </div>

      <div class="card">
        <div class="card-body">
          <h5 class="card-title">
            Header Mall : *Max 500 kb, type file (jpg or png) dan ukuran 1198 x
            200
          </h5>
          <div class="text-center py-3">
            <img
              :src="user.image.header"
              class="img-fluid"
              onerror="imgError(this)"
              width="50%"
            />
          </div>
        </div>

        <form @submit.prevent="editPicture">
          <label for="header"></label>
          <input
            type="file"
            class="form-control-file ml-3"
            name="header"
            id="header"
          />
          <div class="form-group"></div>
          <div class="text-center">
            <button type="submit" class="btn btn-info my-3">
              {{ loading ? "" : "Update Header" }}
            </button>
          </div>
        </form>

        <!-- <form>
          <div class="form-group text-center">
            <label for="header" class="btn btn-outline-primary"> </label>
            <input type="file" id="header" />
          </div>
          <div class="text-center">
            <button type="button" class="btn btn-info my-3">
              {{ loading ? "" : "Update Header" }}
            </button>
          </div>
        </form> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    editPicture: { type: Function },
    loading: Boolean,
  },
  computed: {
    ...mapGetters({
      user: "user",
    }),
  },
};
</script>
